import { render, staticRenderFns } from "./SwiperProduct.vue?vue&type=template&id=991f32b8&scoped=true&"
import script from "./SwiperProduct.vue?vue&type=script&lang=js&"
export * from "./SwiperProduct.vue?vue&type=script&lang=js&"
import style0 from "./SwiperProduct.vue?vue&type=style&index=0&id=991f32b8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991f32b8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductCard: require('/data/jenkins-data/workspace/Unicew-mobile-pro/pagePC/components/ProductCard.vue').default,ViewMoreBtn: require('/data/jenkins-data/workspace/Unicew-mobile-pro/pagePC/components/ViewMoreBtn.vue').default})
